import styled from 'styled-components'

import { DarkLightStyled } from 'components/presentational/theme/DarkLight'

import { photoButtonCss } from '../Panel/Panel.styled'

export const Wrapper = styled.a<DarkLightStyled>`
  ${photoButtonCss};
  width: 40px;
  justify-content: center;
  padding: 0;
  position: absolute;
  ${(props) => props.theme.left}: 0;

  top: 0;
  z-index: 1;
  cursor: pointer;
`
